export const isValidEmail = (email: string) => {
    // eslint-disable-next-line no-useless-escape
    return /(.+)@(.+){2,}\.(.+){2,}/.test(email.trim());
};
